<template lang="html">
  <div id="study-card">
    <div class="header">
      <div class="back-to-toc" @click="$router.go(-1)">
        <v-icon>mdi-chevron-left</v-icon>
        <div class="link-text">Back</div>
      </div>
      <div class="header-content">
        <img :src="StudyCardsIcon">
        <div class="study-card-type">
          Study Cards
        </div>
      </div>
      <div class="header-content">
        <div class="study-card-title">
          {{chapterTitle}}
        </div>
      </div>
    </div>
    <div class="study-card-body">
      <div class="page-container">
        <carousel class="carousel"
          :items=items
          :nav=nav
          :stagePadding=stagePadding
          :navText=navText
          :dots=dots
          :margin=margin
          :rewind=rewind
          :autoHeight=autoHeight
          :startPosition=startPosition
          @changed="updateCardStatus">
            <BaseCard
              v-for="(s, i) in this.sectionContent.StudyCard"
              :key="i">
              <FlipCard
                v-if="s.$.type === 'flip'"
                :studyCardContent="s"
                :bookTitle="bookTitle"
                :chapter="chapter"
                :section="section"
                :key="i" />
              <div class="card" v-html="s.FrontCard[0]" v-else></div>
            </BaseCard>
          </carousel>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import carousel from 'vue-owl-carousel'
import BaseCard from '@/components/study-card/BaseCard'
import FlipCard from '@/components/study-card/FlipCard'
import { mapState, mapActions } from 'vuex'
import StudyCardsIcon from '../../public/img/icons/study_cards_icon.png'

export default {
  name: 'StudyCard',
  components: {
    carousel,
    BaseCard,
    FlipCard
  },
  props: ['chapter', 'section'],
  beforeMount () {
    this.initializeUserProgress()
  },
  mounted () {
    this.formatContents()
    this.addGTMEvent()
  },
  beforeDestroy: function () {
    let tableLength = this.tableElements.length
    for (var i = 0; i < tableLength; i++) {
      this.tableElements[i].removeEventListener('touchstart', this.tableTouchstart)
    }
  },
  data: () => ({
    nav: true,
    items: 1,
    stagePadding: 5,
    dots: false,
    rewind: false,
    margin: 5,
    autoHeight: false,
    navText: ["<span  class='mdi mdi-menu-left'></span>", "<span class='mdi mdi-menu-right'></span>"],
    startPosition: 0,
    StudyCardsIcon
  }),
  methods: {
    ...mapActions({
      setUserProgress: 'user/setUserProgress'
    }),
    async formatContents () {
      setImagesLightBox()
      setTablesSideScroll()
      setCarouselNavigation(this.startPosition + 1)
      await MathJax.typesetPromise()

      this.tableElements = this.$el.querySelectorAll('table')
      this.initTables()
    },
    unflipCards (currentIndex, itemCount) {
      var flippedCardFront = document.querySelector('.owl-item .flipped .card-front.remove')
      if (flippedCardFront) {
        flippedCardFront.classList.remove('remove')
      }

      var flippedCardBack = document.querySelector('.owl-item .flipped .card-back:not(.remove)')
      if (flippedCardBack) {
        flippedCardBack.classList.add('remove')
      }

      var flippedCard = document.querySelector('.owl-item .flipped')
      if (flippedCard) {
        flippedCard.classList.remove('flipped')
      }
    },
    updateCardStatus (event) {
      this.updateNavigationText(event.item.index, event.item.count)
      this.updateUserProgress(event.item.index)
      this.unflipCards(event.item.index, event.item.count)
    },
    updateNavigationText (cardIndex, cardCount) {
      var positionDiv = document.querySelector('.owl-position-text')
      var currentPosition = cardIndex + 1
      positionDiv.innerHTML = currentPosition + '/' + cardCount
    },
    updateUserProgress (currentProgress) {
      this.user.chapterProgress[this.chapterTitle][this.trimmedChapterHeading] = currentProgress
      this.setUserProgress(this.user)
    },
    initializeUserProgress () {
      let currentChapter = this.user.chapterProgress[this.chapterTitle]
      let currentChapterProgress = currentChapter[this.trimmedChapterHeading]
      this.startPosition = currentChapterProgress || 0
    },
    tableTouchstart (e) {
      e.stopPropagation()
    },
    initTables: function () {
      let tableLength = this.tableElements.length
      for (var i = 0; i < tableLength; i++) {
        this.tableElements[i].addEventListener('touchstart', this.tableTouchstart)
      }
    },
    addGTMEvent () {
      let cfVideos = document.querySelectorAll('iframe')

      cfVideos.forEach(cfVideo => {
        let cfPlayer = Stream(cfVideo)
        let isOnLoop = false
        if (cfVideo.src.includes('loop=true')) {
          isOnLoop = true
        }

        cfPlayer.addEventListener('play', () => {
          this.$gtm.trackEvent({
            event: 'user_played_video',
            category: 'Study Cards',
            action: 'play',
            label: 'User played video',
            productName: this.bookTitle,
            chapterName: this.chapter,
            sectionTitle: this.section,
            videoTitle: this.nowPlaying,
            isMediaPlayed: 'true',
            isVideoOnLoop: isOnLoop
          })
        })

        if (!isOnLoop) {
          cfPlayer.addEventListener('ended', () => {
            this.$gtm.trackEvent({
              event: 'user_finished_video',
              category: 'Study Cards',
              action: 'completed',
              label: 'User finished watching video',
              productName: this.bookTitle,
              chapterName: this.chapter,
              sectionTitle: this.section,
              videoTitle: this.nowPlaying,
              isMediaFinished: 'true'
            })
          })
        }
      })
    }
  },
  computed: {
    ...mapState({
      chapterMap: state => state.book.chapterMap,
      chapterHeading: state => state.book.chapterHeading,
      chapterTitle: state => state.book.chapterTitle,
      sectionContent: state => state.book.sectionContent,
      user: state => state.user.user,
      bookTitle: state => state.book.bookTitle
    })
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/variables.scss";
#study-card {
  min-height: 90vh;
  display: flex;
  flex-direction: column;
  height: 100%;
  .header {
    display: flex;
    align-items: center;
    padding: 15px;
    background-color: #f2f2f2;
    .back-to-toc {
      display: flex;
      cursor: pointer;
      .v-icon {
        color: #212121;
      }
      .link-text {
        font-weight: bold;
        font-size: 16px;
      }
    }
    .header-content {
      display: flex;
      align-items: center;
      margin-left: 20px;
      img {
        width: 32px;
        margin-right: 10px;
        display: none;
      }
      .study-card-type {
        font-size: $PageTitle;
      }
      .study-card-title {
        font-size: $PageTitle;
      }
    }
  }
  .study-card-body {
    padding: 16px;
    height: 100%;
    .carousel {
      height: 100%;
      .owl-carousel {
        display: flex;
        flex-direction: column;
        height: 100%;
        .owl-stage-outer {
          .owl-stage {
            height: 100%;
            .owl-item {
              height: 0;
              &.active {
                height: 100%;
                min-height: 60vh;
              }
              .card {
                height: 100%;
                background-color: #fff;
                border-style: solid;
                border-width: 1px;
                border-color: $outline-border-gray;
                padding: 15px;
                overflow-y: auto;
              }
            }
          }
        }
        .owl-nav [class*="owl-"] {
          background: #004855;
        }
      }
    }
  }
  .page-container {
    max-width: 1600px;
    margin: auto;
    height: 100%;
  }
}

@media (max-width: 600px) {
  #study-card {
    .header {
      padding: 15px;
      .header-content {
        .study-card-title {
          display: none;
        }
      }
    }
  }
}

@media (min-width: 1440px) {
  #study-card {
    .header {
      .header-content {
        img {
          display: block;
        }
      }
    }
  }
}

@media (max-width: 1023px) and (orientation: landscape) {
  #study-card {
    font-size: $fontSizeLandscape !important;
    .study-card-body {
      min-height: 90vh;
    }
  }
}

@media (min-width: 601px) {
  #study-card {
    ::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0, 0, 0, 0.5);
      box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    }
  }
}

</style>
